import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  doc,
  getDoc,
  addDoc,
  collection,
  serverTimestamp,
  updateDoc,
  increment
} from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { trackEvent } from "../../utils/analytics";


function SponsorshipCommitment() {
  const navigate = useNavigate();
  const { needId } = useParams();
  const { currentUser, userProfile } = useAuth();

  const [need, setNeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [permissionToShare, setPermissionToShare] = useState(false);
  const [messageToOrg, setMessageToOrg] = useState('');

  useEffect(() => {
    fetchNeed();
  }, [needId]);

  async function fetchNeed() {
    try {
      const snap = await getDoc(doc(db, 'needs', needId));

      if (!snap.exists()) {
        alert('Sponsorship not found.');
        navigate('/give/sponsorships');
        return;
      }

      const data = { id: snap.id, ...snap.data() };

      if ((data.type || 'supply') !== 'sponsorship') {
        alert('This is not a sponsorship.');
        navigate('/give/sponsorships');
        return;
      }

      setNeed(data);
    } catch (err) {
      console.error(err);
      alert('Error loading sponsorship.');
    } finally {
      setLoading(false);
    }
  }

  async function handleCommit() {
    if (!permissionToShare) {
      alert('You must agree to share your information.');
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, 'sponsorshipCommitments'), {
  needId: need.id,
  needTitle: need.itemName,
  orgId: need.orgId,
  orgName: need.orgName,
  donorId: currentUser.uid,
  donorName:
  userProfile?.displayName ||
  userProfile?.name ||
  currentUser?.displayName ||
  '',

donorEmail:
  userProfile?.email ||
  currentUser?.email ||
  '',

donorPhone:
  userProfile?.phone ||
  userProfile?.phoneNumber ||
  '',
  messageToOrg,
  permissionToShare: true,
  status: 'pending_forward',
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp()
});

      await updateDoc(doc(db, 'needs', need.id), {
  sponsorshipInterestCount: increment(1),
  updatedAt: serverTimestamp()
});

      trackEvent("sponsorship_commitment_created", {
        need_id: need.id,
        org_name: need.orgName
      });

      alert('Thank you. The nonprofit will be notified of your sponsorship interest.');

      navigate('/give/dashboard');

    } catch (err) {
      console.error(err);
      alert('Error submitting sponsorship commitment.');
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
        Loading sponsorship...
      </div>
    );
  }

  if (!need) return null;

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f9fafb',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif'
    }}>

      <div style={{
        maxWidth: '760px',
        margin: '0 auto',
        padding: '3rem 2rem'
      }}>

        <button
          onClick={() => navigate('/give/sponsorships')}
          style={{
            marginBottom: '1.5rem',
            background: 'transparent',
            border: 'none',
            color: '#1e3a5f',
            cursor: 'pointer',
            fontWeight: 600
          }}
        >
          ← Back to sponsorships
        </button>

        <div style={{
          background: 'white',
          borderRadius: '16px',
          border: '1px solid #eee',
          padding: '2rem'
        }}>

          <div style={{
            color: '#2d6a4f',
            fontSize: '0.8rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '0.5rem'
          }}>
            Sponsorship commitment
          </div>

          <h1 style={{
            fontSize: '2rem',
            marginBottom: '0.5rem'
          }}>
            {need.itemName}
          </h1>

          <div style={{
            color: '#555',
            marginBottom: '1.5rem'
          }}>
            {need.orgName}
          </div>

          <div style={{
            background: '#f0f7ff',
            border: '1px solid #bfdbfe',
            borderRadius: '12px',
            padding: '1rem',
            marginBottom: '1.5rem',
            lineHeight: 1.6,
            color: '#1e3a5f'
          }}>
            SomebodyGives is not processing sponsorship payments for this opportunity.

            <br /><br />

            By continuing, you are allowing SomebodyGives to share your name,
            email address, phone number, and sponsorship interest with this
            nonprofit organization so they can contact you directly.
          </div>

          <div style={{
            marginBottom: '1.5rem'
          }}>
            <label style={{
              display: 'block',
              fontWeight: 700,
              marginBottom: '0.5rem'
            }}>
              Optional message to organization
            </label>

            <textarea
              value={messageToOrg}
              onChange={(e) => setMessageToOrg(e.target.value)}
              rows={4}
              placeholder="Anything you'd like the nonprofit to know..."
              style={{
                width: '100%',
                padding: '0.85rem',
                borderRadius: '10px',
                border: '1px solid #ddd',
                resize: 'vertical',
                fontFamily: 'inherit',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.75rem',
            marginBottom: '2rem',
            cursor: 'pointer'
          }}>
            <input
              type="checkbox"
              checked={permissionToShare}
              onChange={(e) => setPermissionToShare(e.target.checked)}
              style={{ marginTop: '0.2rem' }}
            />

            <span style={{ lineHeight: 1.5 }}>
              I agree that SomebodyGives may share my contact information
              and sponsorship commitment with this nonprofit organization.
            </span>
          </label>

          <button
            onClick={handleCommit}
            disabled={submitting}
            style={{
              width: '100%',
              background: '#1e3a5f',
              color: 'white',
              border: 'none',
              padding: '1rem',
              borderRadius: '10px',
              fontSize: '1rem',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            {submitting ? 'Submitting...' : 'Submit sponsorship commitment'}
          </button>

        </div>
      </div>
    </div>
  );
}

export default SponsorshipCommitment;